import styled, {ThemeProps} from 'styled-components';

import {Theme} from '@ibibo/build-theme/src/types';

import {
  SectionDefaultStyles,
  ColumnStyles,
  ColumnW100Styles,
  RowW100Styles,
} from '../../common/Layouts/Layouts';

export const OuterWrapDiv = styled.section(
  (props: ThemeProps<Theme>) => `
  ${SectionDefaultStyles}
  display:flex;
  position:sticky;
  top:0;
  z-index: ${props.theme.misc.zIndex.xlarge};
`,
);

export const OuterWrapperStyle = styled.section(
  (props: ThemeProps<Theme>) => `
  ${SectionDefaultStyles}
  background-color: ${props.theme.colors.blue.brand};
`,
);

export const WrapperStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  ${ColumnW100Styles}
  max-width: 120rem;
  margin: 0 auto;
  padding: ${props.theme.spacing.large.l12} 0;
  background-color: ${props.theme.colors.blue.brand};
`,
);

export const InnerWrapperStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  ${RowW100Styles}
  align-items: center;
`,
);

export const SearchOuterWrapper = styled.div(
  props => `
  display:flex;
`,
);

export const SearchWrapperArea = styled.div(
  (props: ThemeProps<Theme>) => `
  ${ColumnStyles}
  position: relative;
`,
);

export const CheckinCheckoutWrapper = styled.div(
  (props: ThemeProps<Theme>) => `
  display: flex;
  flex-direction: column;
  position: relative;
  cursor: pointer;
`,
);

export const ButtonStyle = styled.button(
  (props: ThemeProps<Theme>) => `
  background-image: linear-gradient(96deg, #53b2fe, #065af3);
  box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.2);
  color: white;
  display: inline-block;
  flex-shrink: 0;
  text-transform: uppercase;
  font-weight: ${props.theme.font.fontWeight.black};
  padding: 0.9rem 2rem;
  cursor: pointer;
  border: 0;
  outline: 0;
  align-items: center;
  border-radius: 3rem;
  font-size: ${props.theme.font.large.font18};
  font-family: ${props.theme.font.fontFamily};
  margin-left:3rem;
`,
);
